(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ca-proof-strip"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ca-proof-strip')){customElements.define('ca-proof-strip',class extends HTMLElement{connectedCallback(){this.controller?.abort();this.controller=new AbortController();this.querySelector('.ca-proof-toggle')?.addEventListener('click',()=>{const paused=this.dataset.paused!=='true';this.dataset.paused=String(paused);const button=this.querySelector('.ca-proof-toggle');button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel)},{signal:this.controller.signal})}disconnectedCallback(){this.controller?.abort()}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ca-video-questions"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ca-video-questions')) {
  customElements.define('ca-video-questions', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.ca-vq__track');
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('.ca-vq__player');
      this.addEventListener('click', (event) => {
        const open = event.target.closest('[data-vq-open]');
        const arrow = event.target.closest('[data-vq-direction]');
        if (open) this.openVideo(open);
        if (arrow) this.track.scrollBy({ left: Number(arrow.dataset.vqDirection) * (this.track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        if (event.target.closest('[data-vq-close]')) this.dialog.close();
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => this.clearVideo(), options);
      this.track.addEventListener('scroll', () => this.updateArrows(), options);
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        const card = event.target.closest('.ca-vq__card');
        if (card) this.track.scrollTo({ left: this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'instant' });
      }, options);
      this.observer = new ResizeObserver(() => this.updateArrows());
      this.observer.observe(this.track);
      this.updateArrows();
    }
    updateArrows() {
      const arrows = this.querySelector('.ca-vq__arrows');
      arrows.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
      arrows.querySelector('[data-vq-direction="-1"]').disabled = this.track.scrollLeft <= 2;
      arrows.querySelector('[data-vq-direction="1"]').disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }
    openVideo(button) {
      const template = Array.from(this.querySelectorAll('template[data-vq-template]')).find(item => item.dataset.vqTemplate === button.dataset.vqOpen);
      if (!template) return;
      this.querySelector('.ca-vq__dialog-title').textContent = template.dataset.vqQuestion;
      this.player.replaceChildren(template.content.cloneNode(true));
      this.trigger = button;
      this.dialog.showModal();
      this.querySelector('[data-vq-close]').focus();
      const video = this.player.querySelector('video');
      video.play()?.catch(() => {});
    }
    clearVideo() {
      this.player.querySelectorAll('video').forEach(video => video.pause());
      this.player.replaceChildren();
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.player?.querySelectorAll('video').forEach(video => video.pause());
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
